import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  TextField,
  InputAdornment,
  Card,
  Typography,
  CardContent,
  Collapse,
  IconButton,
  Divider,
  Avatar,
  Chip,
  keyframes,
  Tooltip,
  ToggleButtonGroup,
  ToggleButton,
  Dialog,
  DialogContent,
  MenuItem,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import {
  useGetRequestQuery,
  useResentEmailStaffMutation,
  useGetEmailRecordQuery,
  useGetTeamQuery,
  useGetUserInfoOnyQuery,
  useGetSmsRecordQuery,
  useResentSmsStaffMutation,
  useGetResponedentQuery,
  useCreateRespontantMutation,
  useDeleteRespontantMutation,
} from "../../../Api/attoDeskApi";
import {
  IRequest,
  IUserAdmin,
  IEmailRecords,
  ITeam2,
  ISmsRecords,
  IRequestResponents,
} from "../../../Api/Interface/api.interface";
import DeletePopup from "../../../Components/Delete/ResentEmail";
import { useNotifier } from "../../../Core/Notifier";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { CiSearch } from "react-icons/ci";
import { useNavigate, useParams } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import Pagination from "../../../Components/Pagination";
import { Link } from "react-router-dom";
import UnsubscribeIcon from "@mui/icons-material/Unsubscribe";
import dayjs, { Dayjs } from "dayjs";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import AddIcon from "@mui/icons-material/Add";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { FcOk, FcCancel } from "react-icons/fc";
import { SlLike } from "react-icons/sl";
import { SlDislike } from "react-icons/sl";
import { toProperCase } from "../../../Components/Validation/toProperCase";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import MailOffIcon from "@mui/icons-material/MailOutline";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import ReplayIcon from "@mui/icons-material/Replay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import GroupIcon from "@mui/icons-material/Group";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import EmailIcon from "@mui/icons-material/Email";
import SmsIcon from "@mui/icons-material/Sms";
import { formatPhoneNumberForDisplay } from "../../../Components/Validation/validationUtils";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import SendIcon from "@mui/icons-material/Send";
import useIsMobile from "../../../Core/hook/useIsMobile";
import { requestStatus } from "../../../Core/Enum/enum";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import DeletePopup2 from "../../../Components/Delete/DeletePopup";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';

const lightThemeColor = JSON.parse(
  localStorage.getItem("lightThemeColor") || "{}"
);
const setCardBRadius = lightThemeColor?.cardBorderRadius || "none";

const formatTime = (time: string | undefined) => {
  if (!time) return "";
  const [hour, minute] = time.split(":").map(Number);
  const date = new Date();
  date.setHours(hour, minute);
  return new Intl.DateTimeFormat("en-CA", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  }).format(date);
};

const Index = () => {
  const { id: newsletterId } = useParams<{ id: string }>();
  const classes = useStyles();
  const theme = useTheme();
  const isMobileRes = useIsMobile();
  const { showErrorMessage, showMessage } = useNotifier();
  const [mode, setMode] = React.useState<
    "email" | "sms" | "respondents" | "message"
  >("respondents");

  const [searchQuery, setSearchQuery] = useState("");
  const debouncedSearchQuery = useDebounce(searchQuery, 300);

  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] =
    useState<IEmailRecords | null>(null);

  const [openDeleteCategorySms, setOpenDeleteCategorySms] = useState(false);
  const [coursingToDeleteSms, setCoursingToDeleteSms] =
    useState<ISmsRecords | null>(null);

  const [openOrderListDate, setOpenOrderListDate] = useState(false);
  const [requestToDelete, setrequestToDelete] =
    useState<IRequestResponents | null>(null);

  const [openDeleteCategoryRes, setOpenDeleteCategoryRes] = useState(false);
  const [coursingToDeleteRes, setCoursingToDeleteRes] =
    useState<IRequestResponents | null>(null);

  const [newStatus, { isLoading }] = useCreateRespontantMutation();

  const {
    data: emailRecodData,
    isLoading: newsletterIsLoading,
    isError: newLetterEmailIsError,
    refetch,
  } = useGetEmailRecordQuery({
    requestId: String(newsletterId),
    searchText: "",
    id: "",
    staffId: "",
  });

  const {
    data: requestData,
    isLoading: requestIsLoading,
    isError: requestIsError,
  } = useGetRequestQuery({
    id: String(newsletterId),
    searchText: "",
  });

  const {
    data: smsRecodData,
    isLoading: smsRecordIsLoading,
    isError: smsIsError,
    refetch: smsRefetch,
  } = useGetSmsRecordQuery({
    requestId: String(newsletterId),
    searchText: "",
    id: "",
    staffId: "",
  });

  const {
    data: responentsData,
    isLoading: responentsIsLoading,
    isError: responentsIsError,
    refetch: responentsRefetch,
  } = useGetResponedentQuery({
    requestId: String(newsletterId),
    searchText: "",
    id: "",
    staffId: "",
  });

  const { data: userData, isLoading: userIsLoading } = useGetUserInfoOnyQuery({
    searchText: "",
  });

  const { data: customerDate, isLoading: customerIsLoading } = useGetTeamQuery({
    searchText: "",
    id: "",
  });

  const handleOpenDeletePopup = (coursing: IEmailRecords) => {
    setCoursingToDelete(coursing);
    setOpenDeleteCategory(true);
  };

  const handleCloseDeletePopup = () => {
    setCoursingToDelete(null);
    setOpenDeleteCategory(false);
  };

  const handleOpenDeletePopupSms = (coursing: ISmsRecords) => {
    setCoursingToDeleteSms(coursing);
    setOpenDeleteCategorySms(true);
  };

  const handleCloseDeletePopupSms = () => {
    setCoursingToDeleteSms(null);
    setOpenDeleteCategorySms(false);
  };

  const handleOpenDeletePopupRes = (coursing: IRequestResponents) => {
    setCoursingToDeleteRes(coursing);
    setOpenDeleteCategoryRes(true);
  };

  const handleCloseDeletePopupRes = () => {
    setCoursingToDeleteRes(null);
    setOpenDeleteCategoryRes(false);
  };

  const newsLetterEmail = useMemo(() => {
    if (
      requestData &&
      Array.isArray(requestData.data) &&
      requestData.data.length > 0
    ) {
      return requestData.data[0] as IRequest;
    }
    return null;
  }, [requestData]);

  const customerList = useMemo(() => {
    return customerDate?.data as ITeam2[];
  }, [customerDate?.data]);

  const userList = useMemo(() => {
    return userData?.data as IUserAdmin[];
  }, [userData?.data]);

  const customerMap = useMemo(() => {
    const map = new Map<
      string,
      { fullName: string; email: string; phoneNumber: string; img: string }
    >();

    customerList?.forEach((customer) => {
      map.set(customer.id, {
        fullName:
          toProperCase(customer.teamFirstName || "") +
          " " +
          toProperCase(customer.teamLastName || ""),
        email: customer.teamEmail || "",
        phoneNumber: customer.teamMobileNum || "",
        img: customer.teamImg || "",
      });
    });

    return map;
  }, [customerList]);

  const userMap = useMemo(() => {
    const map = new Map();
    userList?.forEach((user) => {
      map.set(user.id, `${user.user_role_name}`);
    });
    return map;
  }, [userList]);

  const userListMap = useMemo(() => {
    const map = new Map<string, { username: string; userrole: string }>();

    userList?.forEach((customer) => {
      map.set(customer.id, {
        username: customer.username || "",
        userrole: customer.user_role_name || "",
      });
    });

    return map;
  }, [customerList]);

  const handleCloseDialogGenerate = () => {
    setOpenOrderListDate(false);
    setrequestToDelete(null);
  };

  const handleOpenDialogGenerate = (coursing: IRequestResponents) => {
    setrequestToDelete(coursing);
    setOpenOrderListDate(true);
  };

  const [deleteCategory] = useResentEmailStaffMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpenDeleteCategory(false);
        setCoursingToDelete(null);
        refetch();
      } else {
        showErrorMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to resend");
    }
  };

  const [deleteRespondent] = useDeleteRespontantMutation();
  const handleDeleteRes = async (id: string) => {
    try {
      const response = await deleteRespondent(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpenDeleteCategoryRes(false);
        setCoursingToDeleteRes(null);
        responentsRefetch();
      } else {
        showErrorMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to resend");
    }
  };

  const [deleteCategorySms] = useResentSmsStaffMutation();
  const handleDeleteSms = async (id: string) => {
    try {
      const response = await deleteCategorySms(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpenDeleteCategorySms(false);
        setCoursingToDeleteSms(null);
        smsRefetch();
      } else {
        showErrorMessage(response.message);
      }
    } catch (error) {
      showErrorMessage("Failed to resend");
    }
  };

  const formik = useFormik({
    initialValues: {
      id: String(requestToDelete?.id) || "",
      requestId: String(newsletterId) || "",
      status: "Accepted",
      empid: String(requestToDelete?.empid) || "",
      userId: String(requestToDelete?.userId) || "",
    },
    enableReinitialize: true,
    onSubmit: async (values, { resetForm }) => {
      try {
        const temData = {
          ...(requestToDelete?.id && { id: values.id }),
          status: values.status,
          requestId: values.requestId,
          empid: values.empid,
          userId: values.userId,
        };

        const addCompanyResponse = await newStatus(temData).unwrap();
        if (!addCompanyResponse.status) {
          showErrorMessage(addCompanyResponse.message);
        } else {
          showMessage(addCompanyResponse.message);
          resetForm();
          setOpenOrderListDate(false);
          setrequestToDelete(null);
          smsRefetch();
          responentsRefetch();
          responentsRefetch();
        }
      } catch (error) {
        showErrorMessage("Something went wrong");
      }
    },
  });

  const formValid = useMemo(() => {
    return (
      formik.values.status !== "" &&
      formik.values.status !== undefined &&
      formik.values.id !== "" &&
      formik.values.id !== undefined &&
      formik.values.requestId !== "" &&
      formik.values.requestId !== undefined
    );
  }, [formik]);

  const emailRecodDataList: IEmailRecords[] = Array.isArray(
    emailRecodData?.data
  )
    ? (emailRecodData?.data as IEmailRecords[])
    : [];

  const smsRecodDataList: ISmsRecords[] = Array.isArray(smsRecodData?.data)
    ? (smsRecodData?.data as ISmsRecords[])
    : [];

  const responentsDataList: IRequestResponents[] = Array.isArray(
    responentsData?.data
  )
    ? (responentsData?.data as IRequestResponents[])
    : [];

  if (
    newsletterIsLoading ||
    userIsLoading ||
    smsRecordIsLoading ||
    customerIsLoading ||
    responentsIsLoading ||
    requestIsLoading
  )
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <Card className={classes.card}>
            <Grid container spacing={3} p={2}>
              <Grid item xs={12} md={12} lg={12}>
                <Card variant="outlined" className={classes.card}>
                  <CardContent sx={{ cursor: "pointer" }}>
                    <Grid
                      container
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Grid item>
                        <Grid container spacing={1} direction="column">
                          <Grid item>
                            <Typography variant="subtitle1" fontWeight={600}>
                              From: {newsLetterEmail?.fromEmail}
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      {newsLetterEmail?.created_at &&
                        newsLetterEmail?.created_by && (
                          <Grid item>
                            <Grid container spacing={1} direction="column">
                              <Grid item>
                                <Typography
                                  variant="subtitle1"
                                  color="textSecondary"
                                >
                                  {`${
                                    dayjs(newsLetterEmail?.created_at).format(
                                      "MMM-D, YYYY hh:mm A"
                                    ) || ""
                                  } | ${userMap.get(
                                    newsLetterEmail?.created_by
                                  )}`}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                        )}
                    </Grid>
                    <Grid
                      container
                      spacing={1}
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Grid item xs={12} sm={8}>
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          noWrap
                        >
                          Subject: {newsLetterEmail?.subject}
                        </Typography>
                      </Grid>
                      {newsLetterEmail?.schedule_date && (
                        <Grid item xs={12} sm={8}>
                          <Typography variant="body1">
                            Date:{" "}
                            {dayjs(newsLetterEmail?.schedule_date).format(
                              "MMM-D, YYYY"
                            ) || ""}
                          </Typography>
                        </Grid>
                      )}
                      {newsLetterEmail?.startTime &&
                        newsLetterEmail?.endTime && (
                          <Grid item xs={12} sm={8}>
                            <Typography variant="body1">
                              Time: {formatTime(newsLetterEmail.startTime)} -{" "}
                              {formatTime(newsLetterEmail.endTime)}
                              {newsLetterEmail.spansNextDay == true && (
                                <span
                                  style={{
                                    color: "#e3791a",
                                    fontWeight: 600,
                                    lineHeight: 1.5,
                                    fontSize: "0.875rem",
                                    paddingLeft: "1px",
                                  }}
                                >
                                  [next day]
                                </span>
                              )}
                            </Typography>
                          </Grid>
                        )}

                      {newsLetterEmail?.reason && (
                        <Grid item xs={12} sm={8}>
                          <Typography
                            variant="body1"
                            noWrap
                            sx={{ color: "warning.main", fontWeight: 600 }}
                          >
                            Reason: {newsLetterEmail?.reason}
                          </Typography>
                        </Grid>
                      )}

                      <Grid item xs={12} sm="auto">
                        {newsLetterEmail?.final_status === "Active" ? (
                          <Grid container alignItems="center" spacing={1}>
                            <Chip
                              icon={<NotificationsActiveOutlinedIcon />}
                              label="This employee schedule request is currently
                                    active."
                              variant="outlined"
                              color="info"
                              className={classes.chipButton}
                              sx={{ border: "none" }}
                            />
                          </Grid>
                        ) : newsLetterEmail?.final_status === "Completed" ? (
                          <Grid container alignItems="center" spacing={1}>
                            <Chip
                              icon={<CheckCircleIcon />}
                              label="This employee schedule request has been
                              successfully completed."
                              variant="outlined"
                              color="success"
                              className={classes.chipButton}
                              sx={{ border: "none" }}
                            />
                          </Grid>
                        ) : newsLetterEmail?.final_status ===
                          "Past Schedule is not complete" ? (
                          <Grid container alignItems="center" spacing={1}>
                            <Chip
                              icon={<CancelIcon />}
                              label="The schedule request has ended, but it was not fully completed."
                              variant="outlined"
                              color="warning"
                              className={classes.chipButton}
                              sx={{ border: "none" }}
                            />
                          </Grid>
                        ) : newsLetterEmail?.final_status === "Cancel" ? (
                          <Grid container alignItems="center" spacing={1}>
                            <Chip
                              icon={<CancelIcon />}
                              label="This employee schedule request has been
                              cancelled."
                              variant="outlined"
                              color="error"
                              className={classes.chipButton}
                              sx={{ border: "none" }}
                            />
                          </Grid>
                        ) : (
                          <Grid container alignItems="center" spacing={1}>
                            <Chip
                              icon={<CancelIcon />}
                              label="Failed to process the employee schedule request."
                              variant="outlined"
                              color="error"
                              className={classes.chipButton}
                              sx={{ border: "none" }}
                            />
                          </Grid>
                        )}
                      </Grid>
                      <Grid item lg={12} textAlign={"center"}>
                        <Grid
                          container
                          alignItems="center"
                          textAlign={"center"}
                          justifyItems={"center"}
                          justifyContent={"center"}
                          spacing={1}
                        >
                          {newsLetterEmail?.respondents_total !== undefined && (
                            <Grid item>
                              <Chip
                                label={`Respondents: ${newsLetterEmail.respondents_total}`}
                                variant="outlined"
                                color="success"
                                sx={{ fontWeight: 600 }}
                              />
                            </Grid>
                          )}
                          {Boolean(newsLetterEmail?.emailReminder) === true && (
                            <Grid item>
                              <Chip
                                icon={<EmailIcon />}
                                label="Email Reminder"
                                variant="outlined"
                                color="info"
                                sx={{ fontWeight: 600 }}
                              />
                            </Grid>
                          )}

                          {Boolean(newsLetterEmail?.smsReminder) === true && (
                            <Grid item>
                              <Chip
                                icon={<SmsIcon />}
                                label="SMS Reminder"
                                variant="outlined"
                                color="info"
                                sx={{ fontWeight: 600 }}
                              />
                            </Grid>
                          )}
                        </Grid>
                      </Grid>
                      <Grid
                        item
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        pt={2}
                        sx={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <Grid
                          container
                          spacing={1}
                          justifyContent="flex-end"
                          sx={{
                            display: "flex",
                            justifyContent: {
                              xs: "flex-start",
                              md: "flex-end",
                            },
                          }}
                        >
                          <Grid
                            item
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            textAlign={"end"}
                          >
                            <ToggleButtonGroup
                              value={mode}
                              exclusive
                              onChange={(e, value) => value && setMode(value)}
                              size="small"
                              orientation="horizontal"
                              sx={{
                                flexWrap: { xs: "wrap", md: "nowrap" },
                                width: { xs: "100%", md: "auto" },
                                justifyContent: {
                                  xs: "flex-start",
                                  md: "flex-end",
                                },
                              }}
                            >
                              <ToggleButton
                                value="respondents"
                                color="primary"
                                sx={{
                                  textTransform: "none",
                                  gap: 1,
                                  width: { xs: "100%", md: "auto" },
                                }}
                              >
                                <GroupIcon fontSize="small" /> Respondents
                              </ToggleButton>

                              <ToggleButton
                                value="message"
                                color="primary"
                                sx={{
                                  textTransform: "none",
                                  gap: 1,
                                  width: { xs: "100%", md: "auto" },
                                }}
                              >
                                <SendIcon fontSize="small" /> Message
                              </ToggleButton>

                              {Boolean(newsLetterEmail?.emailReminder) ===
                                true && (
                                <ToggleButton
                                  value="email"
                                  color="primary"
                                  sx={{
                                    textTransform: "none",
                                    gap: 1,
                                    width: { xs: "100%", md: "auto" },
                                  }}
                                >
                                  <EmailIcon fontSize="small" /> Email List
                                </ToggleButton>
                              )}

                              {Boolean(newsLetterEmail?.smsReminder) ===
                                true && (
                                <ToggleButton
                                  value="sms"
                                  color="primary"
                                  sx={{
                                    textTransform: "none",
                                    gap: 1,
                                    width: { xs: "100%", md: "auto" },
                                  }}
                                >
                                  <SmsIcon fontSize="small" /> SMS List
                                </ToggleButton>
                              )}
                            </ToggleButtonGroup>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </CardContent>

                  <Divider />
                  {mode === "message" && (
                    <CardContent>
                      <Typography
                        component="div"
                        dangerouslySetInnerHTML={{
                          __html: newsLetterEmail?.message || "",
                        }}
                      />
                    </CardContent>
                  )}
                  {/* {newsLetterEmail?.attachments &&
                    newsLetterEmail?.attachments !== "[]" && (
                      <CardContent sx={{ pt: 2 }}>
                        <Typography
                          variant="subtitle2"
                          fontWeight={600}
                          gutterBottom
                        >
                          Attachments:
                        </Typography>
                        <Grid container spacing={2}>
                          {(() => {
                            let attachments: string[] = [];
                            try {
                              attachments = JSON.parse(
                                newsLetterEmail.attachments
                              );
                            } catch (e) {
                              attachments = [];
                            }

                            return attachments.map((file, index) => {
                              const isImage =
                                /\.(jpeg|jpg|png|gif|webp)$/i.test(file);
                              const isPdf = /\.pdf$/i.test(file);
                              const isVideo = /\.mp4$/i.test(file);

                              return (
                                <Grid item key={index}>
                                  <a
                                    href={file}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      cursor: "pointer",
                                      // display: "inline-block",
                                    }}
                                  >
                                    {isImage && (
                                      <img
                                        src={file}
                                        alt={`attachment-${index}`}
                                        style={{
                                          width: 200,
                                          height: 200,
                                          border: "1px solid #ccc",
                                        }}
                                      />
                                    )}
                                    {isPdf && (
                                      <div
                                        style={{
                                          border: "1px solid #ccc",
                                          width: 200,
                                          height: 200,
                                        }}
                                      >
                                        <object
                                          data={file}
                                          type="application/pdf"
                                          style={{
                                            // border: "1px solid #ccc",
                                            width: 200,
                                            height: 150,
                                          }}
                                        ></object>
                                        <p>
                                          <a
                                            href={file}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            Click here to download
                                          </a>
                                        </p>
                                      </div>
                                    )}
                                    {isVideo && (
                                      <video
                                        controls
                                        style={{
                                          width: 200,
                                          height: 200,
                                          border: "1px solid #ccc",
                                        }}
                                      >
                                        <source src={file} type="video/mp4" />
                                        Your browser does not support the video
                                        tag.
                                      </video>
                                    )}
                                    {!isImage && !isPdf && !isVideo && (
                                      <a
                                        href={file}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style={{ textDecoration: "none" }}
                                      >
                                        <Typography color="primary">
                                          Download File {index + 1}
                                        </Typography>
                                      </a>
                                    )}
                                  </a>
                                </Grid>
                              );
                            });
                          })()}
                        </Grid>
                      </CardContent>
                    )} */}
                </Card>
              </Grid>
            </Grid>
          </Card>
        </Grid>

        {mode === "respondents" &&
          responentsDataList &&
          responentsDataList.length > 0 && (
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.card}>
                <Grid
                  container
                  justifyContent={"space-between"}
                  spacing={5}
                  sx={{ padding: 2 }}
                  className={classes.titleGrid}
                >
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid container spacing={1}>
                      <Grid item>
                        <Typography className={classes.cardTitle}>
                          Respondents List
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid>
                  <TableContainer>
                    <Table className={classes.table}>
                      <TableHead className={classes.tableHeaderRow}>
                        <TableRow>
                          <TableCell className={classes.tablheader}>
                            <strong>Name</strong>
                          </TableCell>
                          <TableCell className={classes.tablheader}>
                            <strong>Status</strong>
                          </TableCell>
                          {Boolean(newsLetterEmail?.is_past_request) ===
                            false && (
                            <TableCell
                              className={classes.tablheader}
                              sx={{ textAlign: "right" }}
                            >
                              <strong>Actions</strong>
                            </TableCell>
                          )}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {responentsIsError ||
                        responentsDataList.length === 0 ? (
                          <TableRow>
                            <TableCell colSpan={20} align="center">
                              {responentsIsError
                                ? "Error fetching data"
                                : "No data available"}
                            </TableCell>
                          </TableRow>
                        ) : (
                          responentsDataList.map(
                            (row: IRequestResponents, index) => {
                              const customer = customerMap.get(row.empid);
                              const user = userListMap.get(row.userId);

                              return (
                                <TableRow
                                  key={index}
                                  className={classes.tableRowHover}
                                >
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    className={classes.tablCell}
                                  >
                                    <Link
                                      to={`/team-history/${row.empid}`}
                                      className={classes.iconLinkPropNormal}
                                    >
                                      <Grid container spacing={1}>
                                        {!isMobileRes && (
                                          <Grid item>
                                            {customer?.img ? (
                                              <Avatar
                                                alt="Img"
                                                src={customer.img}
                                                className={classes.avatatImage}
                                                sx={{
                                                  cursor: "pointer",
                                                }}
                                              />
                                            ) : (
                                              <Avatar
                                                className={classes.avatatImage}
                                              >
                                                {customer?.fullName ? (
                                                  `${customer?.fullName ?? ""}`
                                                    .trim()
                                                    .charAt(0)
                                                    .toUpperCase()
                                                ) : (
                                                  <GroupIcon />
                                                )}
                                              </Avatar>
                                            )}
                                          </Grid>
                                        )}
                                        <Grid
                                          item
                                          textAlign={"left"}
                                          alignContent={"center"}
                                        >
                                          <Typography
                                            className={classes.nameTableList}
                                          >
                                            {customer
                                              ? `${customer.fullName}`
                                              : ""}
                                          </Typography>
                                          {user && (
                                            <Typography
                                              className={classes.mobileListText}
                                            >
                                              {user.username
                                                ? `${user.username} |`
                                                : ""}
                                              {user?.userrole
                                                ? `${user.userrole}`
                                                : ""}
                                            </Typography>
                                          )}
                                        </Grid>
                                      </Grid>
                                    </Link>
                                  </TableCell>
                                  <TableCell
                                    scope="row"
                                    className={classes.tablCell}
                                  >
                                    {row.status === "Request Sent" ? (
                                      <Tooltip
                                        placement="bottom-end"
                                        title="Adimin can Edit"
                                        componentsProps={{
                                          tooltip: {
                                            sx: {
                                              backgroundColor:
                                                theme.palette.cardAdd.bgColor,
                                              color:
                                                theme.palette.heading
                                                  .headingColor,
                                              borderRadius: setCardBRadius,
                                              padding: 1.5,
                                              border: `0.2px solid ${theme.palette.cardAdd.borderColor}`,
                                              fontSize: 13,
                                            },
                                          },
                                          arrow: {
                                            sx: {
                                              color: theme.palette.cardAdd.borderColor,
                                            },
                                          },
                                        }}
                                        arrow
                                      >
                                        <Chip
                                          icon={<SendIcon />}
                                          label="Request Sent"
                                          variant="outlined"
                                          color="warning"
                                          className={classes.chipButton}
                                          sx={{
                                            cursor: "pointer",
                                          }}
                                          onClick={() => {
                                            if (
                                              !newsLetterEmail?.is_past_request
                                            ) {
                                              handleOpenDialogGenerate(row);
                                            }
                                          }}
                                        />
                                      </Tooltip>
                                    ) : row.status === "Accepted" ? (
                                      <Tooltip
                                        placement="bottom-end"
                                        componentsProps={{
                                          tooltip: {
                                            sx: {
                                              backgroundColor:
                                                theme.palette.cardAdd.bgColor,
                                              color:
                                                theme.palette.heading
                                                  .headingColor,
                                              borderRadius: setCardBRadius,
                                              padding: 1.5,
                                              border: `0.2px solid ${theme.palette.cardAdd.borderColor}`,
                                              fontSize: 13,
                                            },
                                          },
                                          arrow: {
                                            sx: {
                                              color: theme.palette.cardAdd.borderColor,
                                            },
                                          },
                                        }}
                                        arrow
                                        title={
                                          <Grid container spacing={1}>
                                            <Grid
                                              item
                                              lg={12}
                                              md={12}
                                              sm={12}
                                              xs={12}
                                            >
                                              <Typography>
                                                Admin can Edit
                                              </Typography>
                                            </Grid>
                                            <Grid
                                              item
                                              lg={12}
                                              md={12}
                                              sm={12}
                                              xs={12}
                                              ml={3}
                                            >
                                              {row?.updated_by && (
                                                <Typography fontSize={13}>
                                                  <strong>Edited by:</strong>{" "}
                                                  {userMap.get(row?.updated_by)}
                                                </Typography>
                                              )}

                                              {row?.updated_at && (
                                                <Typography fontSize={13}>
                                                  <strong>Edited at:</strong>{" "}
                                                  {dayjs(row.updated_at).format(
                                                    "MMM DD, YYYY"
                                                  )}
                                                </Typography>
                                              )}
                                              {Boolean(
                                                row?.isAdminAcsecpeted
                                              ) === true && (
                                                <Typography
                                                  textAlign="right"
                                                  sx={{
                                                    color: "#1976d2",
                                                    fontWeight: 600,
                                                    lineHeight: 1.5,
                                                    fontSize: "0.875rem",
                                                    paddingLeft: "1px",
                                                    fontStyle: "italic",
                                                  }}
                                                >
                                                  Admin Edited
                                                </Typography>
                                              )}
                                            </Grid>
                                          </Grid>
                                        }
                                      >
                                        <Chip
                                          icon={<CheckCircleIcon />}
                                          label="Accepted"
                                          variant="outlined"
                                          color="success"
                                          className={classes.chipButton}
                                          onClick={() => {
                                            if (
                                              !newsLetterEmail?.is_past_request
                                            ) {
                                              handleOpenDialogGenerate(row);
                                            }
                                          }}
                                        />
                                      </Tooltip>
                                    ) : row.status === "Cancel" ? (
                                      <Tooltip
                                        placement="bottom-end"
                                        componentsProps={{
                                          tooltip: {
                                            sx: {
                                              backgroundColor:
                                                theme.palette.cardAdd.bgColor,
                                              color:
                                                theme.palette.heading
                                                  .headingColor,
                                              borderRadius: setCardBRadius,
                                              padding: 1.5,
                                              border: `0.2px solid ${theme.palette.cardAdd.borderColor}`,
                                              fontSize: 13,
                                            },
                                          },
                                          arrow: {
                                            sx: {
                                              color: theme.palette.cardAdd.borderColor,
                                            },
                                          },
                                        }}
                                        arrow
                                        title={
                                          <Grid container spacing={1}>
                                            <Grid
                                              item
                                              lg={12}
                                              md={12}
                                              sm={12}
                                              xs={12}
                                            >
                                              <Typography>
                                                Admin can Edit
                                              </Typography>
                                            </Grid>
                                            <Grid
                                              item
                                              lg={12}
                                              md={12}
                                              sm={12}
                                              xs={12}
                                              ml={3}
                                            >
                                              {row?.updated_by && (
                                                <Typography fontSize={13}>
                                                  <strong>Edited by:</strong>{" "}
                                                  {userMap.get(row?.updated_by)}
                                                </Typography>
                                              )}

                                              {row?.updated_at && (
                                                <Typography fontSize={13}>
                                                  <strong>Edited at:</strong>{" "}
                                                  {dayjs(row.updated_at).format(
                                                    "MMM DD, YYYY"
                                                  )}
                                                </Typography>
                                              )}
                                              {Boolean(
                                                row?.isAdminAcsecpeted
                                              ) === true && (
                                                <Typography
                                                  textAlign="right"
                                                  sx={{
                                                    color: "#1976d2",
                                                    fontWeight: 600,
                                                    lineHeight: 1.5,
                                                    fontSize: "0.875rem",
                                                    paddingLeft: "1px",
                                                    fontStyle: "italic",
                                                  }}
                                                >
                                                  Admin Edited
                                                </Typography>
                                              )}
                                            </Grid>
                                          </Grid>
                                        }
                                      >
                                        <Chip
                                          icon={<CancelOutlinedIcon />}
                                          label="Cancel"
                                          variant="outlined"
                                          color="error"
                                          className={classes.chipButton}
                                          onClick={() => {
                                            if (
                                              !newsLetterEmail?.is_past_request
                                            ) {
                                              handleOpenDialogGenerate(row);
                                            }
                                          }}
                                        />
                                      </Tooltip>
                                    ) : (
                                      <Tooltip
                                        placement="bottom-end"
                                        componentsProps={{
                                          tooltip: {
                                            sx: {
                                              backgroundColor:
                                                theme.palette.cardAdd.bgColor,
                                              color:
                                                theme.palette.heading
                                                  .headingColor,
                                              borderRadius: setCardBRadius,
                                              padding: 1.5,
                                              border: `0.2px solid ${theme.palette.cardAdd.borderColor}`,
                                              fontSize: 13,
                                            },
                                          },
                                          arrow: {
                                            sx: {
                                              color: theme.palette.cardAdd.borderColor,
                                            },
                                          },
                                        }}
                                        arrow
                                        title={
                                          <Grid container spacing={1}>
                                            <Grid
                                              item
                                              lg={12}
                                              md={12}
                                              sm={12}
                                              xs={12}
                                            >
                                              <Typography>
                                                Admin can Edit
                                              </Typography>
                                            </Grid>
                                            <Grid
                                              item
                                              lg={12}
                                              md={12}
                                              sm={12}
                                              xs={12}
                                              ml={3}
                                            >
                                              {row?.updated_by && (
                                                <Typography fontSize={13}>
                                                  <strong>Edited by:</strong>{" "}
                                                  {userMap.get(row?.updated_by)}
                                                </Typography>
                                              )}

                                              {row?.updated_at && (
                                                <Typography fontSize={13}>
                                                  <strong>Edited at:</strong>{" "}
                                                  {dayjs(row.updated_at).format(
                                                    "MMM DD, YYYY"
                                                  )}
                                                </Typography>
                                              )}
                                              {Boolean(
                                                row?.isAdminAcsecpeted
                                              ) === true && (
                                                <Typography
                                                  textAlign="right"
                                                  sx={{
                                                    color: "#1976d2",
                                                    fontWeight: 600,
                                                    lineHeight: 1.5,
                                                    fontSize: "0.875rem",
                                                    paddingLeft: "1px",
                                                    fontStyle: "italic",
                                                  }}
                                                >
                                                  Admin Edited
                                                </Typography>
                                              )}
                                            </Grid>
                                          </Grid>
                                        }
                                      >
                                        <Chip
                                          icon={<ErrorOutlineIcon />}
                                          label="Failed"
                                          variant="outlined"
                                          color="error"
                                          className={classes.chipButton}
                                          sx={{ cursor: "pointer" }}
                                          onClick={() => {
                                            if (
                                              !newsLetterEmail?.is_past_request
                                            ) {
                                              handleOpenDialogGenerate(row);
                                            }
                                          }}
                                        />
                                      </Tooltip>
                                    )}
                                  </TableCell>
                                  {Boolean(newsLetterEmail?.is_past_request) ===
                                    false && (
                                    <TableCell className={classes.tablCell}>
                                      <Grid
                                        container
                                        spacing={1}
                                        sx={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                        }}
                                      >
                                        {/* {row.id !== "Accepted" && ( */}
                                        {/* <Grid item>
                                          <Button
                                            className={classes.editButtonList}
                                            onClick={() =>
                                              handleOpenDialogGenerate(row)
                                            }
                                          >
                                            <EditSharpIcon
                                              className={classes.editListIcon}
                                            />
                                          </Button>
                                        </Grid> */}
                                        {/* )} */}
                                        {row.id && (
                                          <Grid item>
                                            <Button
                                              // variant="contained"
                                              className={
                                                classes.deleteButtonList
                                              }
                                              // onClick={() =>
                                              //   handleOpenDeletePopupRes(row)
                                              // }
                                              onClick={() => {
                                                if (
                                                  !newsLetterEmail?.is_past_request
                                                ) {
                                                  handleOpenDeletePopupRes(row);
                                                }
                                              }}
                                            >
                                              <DeleteOutlineSharpIcon
                                                className={
                                                  classes.deleteListIcon
                                                }
                                              />
                                            </Button>
                                            <div></div>
                                          </Grid>
                                        )}
                                      </Grid>
                                    </TableCell>
                                  )}
                                </TableRow>
                              );
                            }
                          )
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {coursingToDeleteRes && (
                    <DeletePopup2
                      open={openDeleteCategoryRes}
                      handleCloseDelete={handleCloseDeletePopupRes}
                      onConfirm={async () => {
                        await handleDeleteRes(
                          coursingToDeleteRes.id.toString()
                        );
                      }}
                      title="Delete Request"
                      content={`Are you sure you want to delete request the sms to ${
                        customerMap.get(coursingToDeleteRes.empid)?.fullName ||
                        "this staff member"
                      }?`}
                    />
                  )}
                </Grid>
              </Card>
            </Grid>
          )}

        {Boolean(newsLetterEmail?.emailReminder) === true &&
          mode === "email" &&
          emailRecodDataList &&
          emailRecodDataList.length > 0 && (
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.card}>
                <Grid
                  container
                  justifyContent={"space-between"}
                  spacing={5}
                  sx={{ padding: 2 }}
                  className={classes.titleGrid}
                >
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid container spacing={1}>
                      <Grid item>
                        <Typography className={classes.cardTitle}>
                          Email List
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid>
                  <TableContainer>
                    <Table className={classes.table}>
                      <TableHead className={classes.tableHeaderRow}>
                        <TableRow>
                          <TableCell className={classes.tablheader}>
                            <strong>Name</strong>
                          </TableCell>
                          <TableCell className={classes.tablheader}>
                            <strong>Status</strong>
                          </TableCell>

                          {Boolean(newsLetterEmail?.is_past_request) ===
                            false && (
                            <TableCell
                              className={classes.tablheader}
                              sx={{ textAlign: "right" }}
                            >
                              <strong>Actions</strong>
                            </TableCell>
                          )}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {requestIsError || emailRecodDataList.length === 0 ? (
                          <TableRow>
                            <TableCell colSpan={20} align="center">
                              {requestIsError
                                ? "Error fetching data"
                                : "No data available"}
                            </TableCell>
                          </TableRow>
                        ) : (
                          emailRecodDataList.map(
                            (row: IEmailRecords, index) => {
                              const customer = customerMap.get(row.staffId);
                              return (
                                <TableRow
                                  key={row.id}
                                  className={classes.tableRowHover}
                                >
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    className={classes.tablCell}
                                  >
                                    <Link
                                      to={`/team-history/${row.staffId}`}
                                      className={classes.iconLinkPropNormal}
                                    >
                                      <Grid container spacing={1}>
                                        {!isMobileRes && (
                                          <Grid item>
                                            {customer?.img ? (
                                              <Avatar
                                                alt="Img"
                                                src={customer.img}
                                                className={classes.avatatImage}
                                                sx={{
                                                  cursor: "pointer",
                                                }}
                                              />
                                            ) : (
                                              <Avatar
                                                className={classes.avatatImage}
                                              >
                                                {customer?.fullName ? (
                                                  `${customer?.fullName ?? ""}`
                                                    .trim()
                                                    .charAt(0)
                                                    .toUpperCase()
                                                ) : (
                                                  <GroupIcon />
                                                )}
                                              </Avatar>
                                            )}
                                          </Grid>
                                        )}
                                        <Grid
                                          item
                                          textAlign={"left"}
                                          alignContent={"center"}
                                        >
                                          <Typography
                                            className={classes.nameTableList}
                                          >
                                            {customer
                                              ? `${customer.fullName}`
                                              : ""}
                                          </Typography>
                                          <Typography
                                            className={classes.mobileListText}
                                          >
                                            {row.toEmail
                                              ? `${row.toEmail}`
                                              : `${customer?.email}`}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    </Link>
                                  </TableCell>
                                  <TableCell
                                    scope="row"
                                    className={classes.tablCell}
                                  >
                                    {row.status === "Sent" ? (
                                      <Chip
                                        icon={<CheckCircleIcon />}
                                        label="Email Sent"
                                        variant="outlined"
                                        color="success"
                                        className={classes.chipButton}
                                      />
                                    ) : (
                                      <Tooltip
                                        placement="bottom-end"
                                        title={
                                          row.error_message ||
                                          "Failed to send email"
                                        }
                                        componentsProps={{
                                          tooltip: {
                                            sx: {
                                              backgroundColor:
                                                theme.palette.cardAdd.bgColor,
                                              color:
                                                theme.palette.heading
                                                  .headingColor,
                                              borderRadius: setCardBRadius,
                                              padding: 1.5,
                                              border: `0.2px solid ${theme.palette.cardAdd.borderColor}`,
                                              fontSize: 13,
                                            },
                                          },
                                          arrow: {
                                            sx: {
                                              color: theme.palette.cardAdd.borderColor,
                                            },
                                          },
                                        }}
                                        arrow
                                      >
                                        <Chip
                                          icon={<ErrorOutlineIcon />}
                                          label="Send Failed"
                                          variant="outlined"
                                          color="error"
                                          className={classes.chipButton}
                                          sx={{
                                            cursor: "pointer",
                                          }}
                                        />
                                      </Tooltip>
                                    )}
                                  </TableCell>
                                  {Boolean(newsLetterEmail?.is_past_request) ===
                                    false && (
                                    <TableCell className={classes.tablCell}>
                                      <Grid
                                        container
                                        spacing={1}
                                        sx={{
                                          display: "flex",
                                          justifyContent: "flex-end",
                                        }}
                                      >
                                        <Grid item>
                                          {row.status !== "Sent" && (
                                            <Button
                                              variant="contained"
                                              className={classes.addButton}
                                              startIcon={<ReplayIcon />}
                                              onClick={() =>
                                                handleOpenDeletePopup(row)
                                              }
                                              disabled={!customer?.email}
                                            >
                                              Resent
                                            </Button>
                                          )}
                                          {row.status === "No email found" &&
                                            !customer?.email && (
                                              <div>
                                                <Typography
                                                  sx={{
                                                    fontStyle: "italic",
                                                    color: "#a75252",
                                                    fontWeight: 550,
                                                  }}
                                                  color="textSecondary"
                                                  variant="body2"
                                                >
                                                  -- No email found for staff --
                                                </Typography>
                                              </div>
                                            )}
                                        </Grid>
                                      </Grid>
                                    </TableCell>
                                  )}
                                </TableRow>
                              );
                            }
                          )
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {coursingToDelete && (
                    <DeletePopup
                      open={openDeleteCategory}
                      handleCloseDelete={handleCloseDeletePopup}
                      onConfirm={async () => {
                        await handleDelete(coursingToDelete.id.toString());
                      }}
                      title="Resent E-mail"
                      content={`Are you sure you want to resend the e-mail to ${
                        customerMap.get(coursingToDelete.staffId)?.fullName ||
                        "this staff member"
                      } (${
                        customerMap.get(coursingToDelete.staffId)?.email ||
                        "email not available"
                      })?`}
                    />
                  )}
                </Grid>
              </Card>
            </Grid>
          )}

        {Boolean(newsLetterEmail?.smsReminder) === true &&
          mode === "sms" &&
          smsRecodDataList &&
          smsRecodDataList.length > 0 && (
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.card}>
                <Grid
                  container
                  justifyContent={"space-between"}
                  spacing={5}
                  sx={{ padding: 2 }}
                  className={classes.titleGrid}
                >
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Grid container spacing={1}>
                      <Grid item>
                        <Typography className={classes.cardTitle}>
                          Sms List
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid>
                  <TableContainer>
                    <Table className={classes.table}>
                      <TableHead className={classes.tableHeaderRow}>
                        <TableRow>
                          <TableCell className={classes.tablheader}>
                            <strong>Name</strong>
                          </TableCell>
                          <TableCell className={classes.tablheader}>
                            <strong>Status</strong>
                          </TableCell>
                          {Boolean(newsLetterEmail?.is_past_request) ===
                            false && (
                            <TableCell
                              className={classes.tablheader}
                              sx={{ textAlign: "right" }}
                            >
                              <strong>Actions</strong>
                            </TableCell>
                          )}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {requestIsError || smsRecodDataList.length === 0 ? (
                          <TableRow>
                            <TableCell colSpan={20} align="center">
                              {requestIsError
                                ? "Error fetching data"
                                : "No data available"}
                            </TableCell>
                          </TableRow>
                        ) : (
                          smsRecodDataList.map((row: ISmsRecords, index) => {
                            const customer = customerMap.get(row.staffId);
                            return (
                              <TableRow
                                key={row.id}
                                className={classes.tableRowHover}
                              >
                                <TableCell
                                  component="th"
                                  scope="row"
                                  className={classes.tablCell}
                                >
                                  <Link
                                    to={`/team-history/${row.staffId}`}
                                    className={classes.iconLinkPropNormal}
                                  >
                                    <Grid container spacing={1}>
                                      {!isMobileRes && (
                                        <Grid item>
                                          {customer?.img ? (
                                            <Avatar
                                              alt="Img"
                                              src={customer.img}
                                              className={classes.avatatImage}
                                              sx={{
                                                cursor: "pointer",
                                              }}
                                            />
                                          ) : (
                                            <Avatar
                                              className={classes.avatatImage}
                                            >
                                              {customer?.fullName ? (
                                                `${customer?.fullName ?? ""}`
                                                  .trim()
                                                  .charAt(0)
                                                  .toUpperCase()
                                              ) : (
                                                <GroupIcon />
                                              )}
                                            </Avatar>
                                          )}
                                        </Grid>
                                      )}
                                      <Grid
                                        item
                                        textAlign={"left"}
                                        alignContent={"left"}
                                      >
                                        <Typography
                                          className={classes.nameTableList}
                                        >
                                          {customer
                                            ? `${customer.fullName}`
                                            : ""}
                                        </Typography>
                                        <Typography
                                          className={classes.mobileListText}
                                        >
                                          {row.toMobileNumber
                                            ? `${formatPhoneNumberForDisplay(
                                                row.toMobileNumber
                                              )}`
                                            : `${formatPhoneNumberForDisplay(
                                                customer?.phoneNumber
                                              )}`}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </Link>
                                </TableCell>
                                <TableCell
                                  scope="row"
                                  className={classes.tablCell}
                                >
                                  {row.status === "Sent" ? (
                                    <Chip
                                      icon={<CheckCircleIcon />}
                                      label="Email Sent"
                                      variant="outlined"
                                      color="success"
                                      className={classes.chipButton}
                                    />
                                  ) : (
                                    <Tooltip
                                      placement="bottom-end"
                                      componentsProps={{
                                        tooltip: {
                                          sx: {
                                            backgroundColor:
                                              theme.palette.cardAdd.bgColor,
                                            color:
                                              theme.palette.heading
                                                .headingColor,
                                            borderRadius: setCardBRadius,
                                            padding: 1.5,
                                            border: `0.2px solid ${theme.palette.cardAdd.borderColor}`,
                                            fontSize: 13,
                                          },
                                        },
                                        arrow: {
                                          sx: {
                                            color: theme.palette.cardAdd.borderColor,
                                          },
                                        },
                                      }}
                                      arrow
                                      title={
                                        row.error_message ||
                                        "Failed to send email"
                                      }
                                    >
                                      <Chip
                                        icon={<ErrorOutlineIcon />}
                                        label="Send Failed"
                                        variant="outlined"
                                        color="error"
                                        className={classes.chipButton}
                                        sx={{
                                          cursor: "pointer",
                                        }}
                                      />
                                    </Tooltip>
                                  )}
                                </TableCell>
                                {Boolean(newsLetterEmail?.is_past_request) ===
                                  false && (
                                  <TableCell className={classes.tablCell}>
                                    <Grid
                                      container
                                      spacing={1}
                                      sx={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      <Grid item>
                                        {row.status !== "Sent" && (
                                          <Button
                                            variant="contained"
                                            className={classes.addButton}
                                            startIcon={<ReplayIcon />}
                                            onClick={() =>
                                              handleOpenDeletePopupSms(row)
                                            }
                                            disabled={!customer?.phoneNumber}
                                          >
                                            Resent
                                          </Button>
                                        )}
                                        {row.status ===
                                          "No phone number found" &&
                                          !customer?.phoneNumber && (
                                            <div>
                                              <Typography
                                                sx={{
                                                  fontStyle: "italic",
                                                  color: "#a75252",
                                                  fontWeight: 550,
                                                }}
                                                color="textSecondary"
                                                variant="body2"
                                              >
                                                -- No Mobile Number found for
                                                staff --
                                              </Typography>
                                            </div>
                                          )}
                                      </Grid>
                                    </Grid>
                                  </TableCell>
                                )}
                              </TableRow>
                            );
                          })
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  {coursingToDeleteSms && (
                    <DeletePopup
                      open={openDeleteCategorySms}
                      handleCloseDelete={handleCloseDeletePopupSms}
                      onConfirm={async () => {
                        await handleDeleteSms(
                          coursingToDeleteSms.id.toString()
                        );
                      }}
                      title="Resent Sms"
                      content={`Are you sure you want to resend the sms to ${
                        customerMap.get(coursingToDeleteSms.staffId)
                          ?.fullName || "this staff member"
                      } (${formatPhoneNumberForDisplay(
                        coursingToDeleteSms.toMobileNumber
                      )})?`}
                    />
                  )}
                </Grid>
              </Card>
            </Grid>
          )}

        <Dialog
          open={openOrderListDate}
          onClose={handleCloseDialogGenerate}
          sx={{ padding: 5, minWidth: 450 }}
        >
          <Grid className={isMobileRes ? classes.DialogMobile : classes.Dialog}>
            <form onSubmit={formik.handleSubmit}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={5}
                sx={{ borderBottom: 2, padding: 2 }}
                className={classes.titleGrid}
              >
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  pt={2}
                  alignContent={"center"}
                >
                  <Typography className={classes.cardTitle}>
                    Request Confirmation
                  </Typography>
                </Grid>
              </Grid>
              <DialogContent>
                <DialogContentText sx={{ pt: 3 }}>
                  Are you sure you want to proceed with this schedule request?
                  <div style={{paddingTop: "2px"}}>Please select one of the actions below to continue.</div>
                </DialogContentText>
                <Grid container alignItems="center">
                  <Grid item lg={12} md={12} sm={12} xs={12} pt={3}>
                    <TextField
                      select
                      size="small"
                      className={classes.textField}
                      SelectProps={{
                        native: false,
                      }}
                      defaultValue=""
                      InputLabelProps={{ shrink: true }}
                      {...formik.getFieldProps("status")}
                    >
                      <MenuItem value="" disabled>
                        Select some option
                      </MenuItem>

                      {Object.entries(requestStatus).map(
                        ([key, value], index) => (
                          <MenuItem key={index} value={value}>
                            {key}
                          </MenuItem>
                        )
                      )}
                    </TextField>
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="outlined"
                  startIcon={<CloseIcon />}
                  className={classes.addButton}
                  onClick={handleCloseDialogGenerate}
                >
                  Cancel
                </Button>
                <Box m={0.5}></Box>

                <Button
                  variant="contained"
                  startIcon={<CheckCircleOutlineIcon />}
                  className={classes.addButton}
                  onClick={() => formik.handleSubmit()}
                  disabled={!formValid || isLoading}
                >
                  Confirm
                </Button>
              </DialogActions>
            </form>
          </Grid>
        </Dialog>
      </Grid>
    </div>
  );
};

export default Index;
